<template>
  <div class="card">
    <div class="card-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <div :id="chartId" class="ct-chart"></div>
    </div>
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import Card from './Card.vue'
import Chartist from 'chartist'
import 'chartist/dist/chartist.min.css'
import { nextTick } from 'vue'

export default {
  name: 'chart-card',
  components: { Card },
  props: {
    chartType: {
      type: String,
      default: 'Line' // Line | Pie | Bar
    },
    chartOptions: {
      type: Object,
      default: () => ({})
    },
    chartData: {
      type: Object,
      default: () => ({
        labels: [],
        series: []
      })
    },
    responsiveOptions: [Object, Array]
  },
  data () {
    return {
      chartId: 'no-id',
      chart: null
    }
  },
  methods: {
    initChart () {
      const chartElement = document.getElementById(this.chartId)

      if (!chartElement) {
        console.error(`Chart element with ID "${this.chartId}" not found in DOM`)
        return
      }

      let chartFn = null
      switch (this.chartType) {
        case 'Pie': chartFn = Chartist.Pie; break
        case 'Bar': chartFn = Chartist.Bar; break
        case 'Line': chartFn = Chartist.Line; break
        default:
          console.error('Invalid chart type:', this.chartType)
          return
      }

      if (typeof chartFn !== 'function') {
        console.error(`${this.chartType} is not a function on Chartist`, Chartist)
        return
      }

      this.chart = new chartFn(chartElement, this.chartData, this.chartOptions, this.responsiveOptions)
      this.$emit('initialized', this.chart)

      if (this.chartType === 'Line') this.animateLineChart()
      if (this.chartType === 'Bar') this.animateBarChart()
    },

    updateChartId () {
      const currentTime = new Date().getTime().toString()
      const randomInt = this.getRandomInt(0, currentTime)
      this.chartId = `div_${randomInt}`
    },

    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },

    animateLineChart () {
      let seq = 0
      const durations = 500
      const delays = 80
      this.chart.on('draw', (data) => {
        if (data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          })
        } else if (data.type === 'point') {
          seq++
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          })
        }
      })
    },

    animateBarChart () {
      let seq = 0
      const durations = 500
      const delays = 80
      this.chart.on('draw', (data) => {
        if (data.type === 'bar') {
          seq++
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          })
        }
      })
    }
  },

  mounted () {
    this.updateChartId()
    nextTick(() => {
      this.initChart()
    })
  }
}
</script>

<style>
/* Add custom chart or card styling here if needed */
</style>